import React, {Component,PropTypes} from 'react'
import firebase from '../../config/database'
import Indicator from '../Indicator'

class Videoupload extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
      isLoading:false,
      max_size: "20",
      idclinica: "",
    };
    this.handleChangeFile=this.handleChangeFile.bind(this);
    this.saveFileLinkInFirebase=this.saveFileLinkInFirebase.bind(this);
   
  }

  findFirestoreRelatedData(){

     
    var db = firebase.app.firestore();
    //COLLECTIONS - GET DOCUMENTS 
   
    var _this=this;
    var user = firebase.app.auth().currentUser;
   
    var database = firebase.app.firestore();


      // GET ID CLINICA

     

             database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {

                Snapshot.forEach(function(docupdate) {

                    var usuariupdate = docupdate.data();

                    

                    // save the info related to the clinica

                    _this.setState({
                      idclinica: usuariupdate.clinica, 
                     });
                    
                    
                   // GET MAX SIZE 

                   var docRef = db.collection("cliniques").doc(usuariupdate.clinica);

                   docRef.get().then(function(doc) {
                    if (doc.exists) {
                       
                       var currentDocument=doc.data();
                       console.log("Max size for videos", currentDocument.max_size_video_upload);
                       _this.setState({
                         max_size: currentDocument.max_size_video_upload, 
                        });

                     } else {
                       // doc.data() will be undefined in this case
                        console.log("No info about max size use default");
                              _this.setState({
                                max_size: 20, 
                               });

                         }
                         }).catch(function(error) {
                    console.log("Error getting document:", error);
                     });
                     

               });

             });  


  }



  saveFileLinkInFirebase(link){
    console.log(link);
    this.setState({
      value: link,
      isLoading:false
    });
    this.props.updateAction(this.props.theKey,link);
  }

  

  handleChangeFile(e) {
    this.setState({isLoading:true});
     e.preventDefault();
    console.log("Start processing ....")

    let reader = new FileReader();
    let file = e.target.files[0];

    console.log(file.name);
    var _this=this;

    var linkstorage = "videos_propios/" + _this.state.idclinica + "/";

    var storageRef = firebase.app.storage().ref(linkstorage);
    var refFile=new Date().getTime()+"_"+file.name;

    // Create a reference to the new file

   

    var uploadTask = storageRef.child(refFile).put(file);
  

   // Get the information about the


    uploadTask.on('state_changed', function(snapshot){

     //Get info about max size


      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      if ( snapshot.totalBytes > _this.state.max_size*1024*1024) {
         // Size is bigger than 20MB so we don't update the image 
         
         _this.setState({
          value: "Fichero demasiado grande",
          isLoading:false
        });
        
         console.log ('Upload is canceled due to a large file');
         uploadTask.cancel();

      } else {
      console.log('Upload is ' + progress + '% done');
  
      
    }
    }, function(error) {
      // Handle unsuccessful uploads
      _this.setState({
        value: "Error al cargar el fichero",
        isLoading:false
      });
      console.log('Upload is canceled due to an unknown error');


    }, function() {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        _this.saveFileLinkInFirebase(downloadURL);
        console.log('File available at', downloadURL);
      });
      
    });



  }


  componentDidMount(){
    if(this.props.isFirestore){
      
      this.findFirestoreRelatedData();
    }else{
     
      this.findFirebaseRelatedData();
    }
  }

  render() {
    var imgSrc=this.state.value&&this.state.value.length>4?this.state.value:"";
    var count=80;
    return (
      <div>
      <br />
      <a href={imgSrc} className={this.props.class+" form-control"} target="_blank">{imgSrc.replace("https://firebasestorage.googleapis.com","").slice(0, count) + (imgSrc.length > count ? "..." : "")}</a>
      <div className="fileinput fileinput-new text-center" data-provides="fileinputaa">
        <div>
            <span className="btn btn-rose btn-round btn-file">
                <span className="fileinput-new">Select file Max {this.state.max_size} MB</span>
                <span className="fileinput-exists">Change</span>
                <input type="file" style={{width:'2000px'}} id={this.props.theKey} name={this.props.theKey}  onChange={this.handleChangeFile} />
            </span>
            <Indicator show={this.state.isLoading} />
            <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
        </div>


    </div>
    </div>


    )
  }
}
export default Videoupload;

Videoupload.propTypes = {
    updateAction:PropTypes.func.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    class: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/fields/Videoupload.js